var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHammerFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 11.2687L7.39375 4.125L6.95 3.6875L7.8375 2.79375L6.5 1.43125C7.25 0.6875 8.43125 0.6875 9.16875 1.43125L11.4188 3.6875L10.5312 4.56875H12.3063L12.75 5.0125L10.5312 7.25625L10.0875 6.8125V5.0125L9.16875 5.9L8.725 5.45625L1.58125 12.6L0.25 11.2687Z",
    fill: "black",
    fillOpacity: 0.66
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammerFill);
export default __webpack_public_path__ + "static/media/HammerFill.ee1971cc.svg";
export { ForwardRef as ReactComponent };